<template>
  <!-- Drawer Overlay -->
  <div
    v-if="isOpen"
    class="fixed inset-0 font-inter bg-eerie-black bg-opacity-50 z-50"
    @click="closeDrawer"
  >
    <!-- Drawer Content -->
    <div
      class="fixed top-0 text-lg pt-52 right-0 w-64 border-l border-total-white-300 h-screen bg-eerie-black text-total-white shadow-lg"
      @click.stop
    >
      <!-- Close Button -->
      <button class="absolute top-5 left-5" @click="closeDrawer">
        <i class="fas fa-times text-xl text-total-white"></i>
      </button>

      <!-- Reply Options -->
      <div class="w-full text-prime-golden">
        <button
          @click="replyAll"
          class="w-full grid items-center grid-cols-[1fr_2fr] border-y border-total-white-300 p-4"
        >
          <i class="fas fa-reply-all text-prime-golden"></i>
          <span class="place-self-center">Reply All</span>
        </button>

        <button
          @click="reply"
          class="w-full grid items-center grid-cols-[1fr_2fr] border-y border-total-white-300 p-4"
        >
          <i class="fas fa-reply text-prime-golden"></i>
          <span class="place-self-center">Reply</span>
        </button>

        <button
          @click="forward"
          class="w-full grid items-center grid-cols-[1fr_2fr] border-y border-total-white-300 p-4"
        >
          <i class="fas fa-share text-prime-golden"></i>
          <span class="place-self-center">Forward</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    emailData: {
      type: Object,
      required: true,
    },
    userEmail: {
      type: String,
      required: true,
    },
    projectId: {
      type: Number,
      required: true,
    },
  },
  methods: {
    closeDrawer() {
      this.$emit("close");
    },

    reply() {
      // Convert the "to" string to an array (handle empty to gracefully)
      this.$emit("openEmailForm", {
        type: "reply",
        toEmails: [this.emailData.sender], // pass array of recipients
        ccEmail: "",
        bccEmail: "",
        subject: `${this.emailData.subject}`,
        project: this.emailData.project,
        projectId: this.projectId,
        threadId: this.emailData.threadId,
      });
    },

    replyAll() {
      let toList = this.emailData.to
        ? this.emailData.to
            .split(",")
            .map((e) => e.trim())
            .filter((e) => e)
        : [];
      let ccList = this.emailData.cc
        ? this.emailData.cc
            .split(",")
            .map((e) => e.trim())
            .filter((e) => e)
        : [];

      // For replyAll we also add the original sender if not already included.
      // But then we need to adjust based on whether the sender is PM/self.
      const isSenderPm = this.emailData.sender === this.userEmail;

      if (!isSenderPm) {
        // Original sender is not PM/self.
        // Ensure the sender is included as the first recipient.
        if (this.emailData.sender && !toList.includes(this.emailData.sender)) {
          toList.unshift(this.emailData.sender);
        }
        // Remove the PM/self's email from the To/CC lists.
        toList = toList.filter((email) => email !== this.userEmail);
        ccList = ccList.filter((email) => email !== this.userEmail);
      } else {
        // Original sender is PM/self.
        // For Reply All, include PM/self in To only if they were originally in To or CC.
        const pmInOriginal =
          (this.emailData.to && this.emailData.to.includes(this.userEmail)) ||
          (this.emailData.cc && this.emailData.cc.includes(this.userEmail));
        if (pmInOriginal) {
          if (!toList.includes(this.userEmail)) {
            toList.unshift(this.userEmail);
          }
        } else {
          // If PM/self wasn't originally in To/CC, exclude them.
          toList = toList.filter((email) => email !== this.userEmail);
          ccList = ccList.filter((email) => email !== this.userEmail);
        }
      }

      // Remove duplicates.
      toList = [...new Set(toList)];
      ccList = [...new Set(ccList)];
      console.log(toList, "tolist", ccList);

      this.$emit("openEmailForm", {
        type: "replyAll",
        to: toList.join(", "),
        ccEmail: ccList.join(", "),
        bccEmail: "",
        subject: `${this.emailData.subject}`,
        project: this.emailData.project,
        projectId: this.projectId,
        threadId: this.emailData.threadId,
      });
    },

    forward() {
      this.$emit("openEmailForm", {
        type: "forward",
        to: "",
        ccEmail: "",
        bccEmail: "",
        subject: `Fwd: ${this.emailData.subject}`,
        body: this.emailData.body,
        project: this.emailData.project,
        projectId: this.projectId,
        threadId: this.emailData.threadId,
      });
    },
  },
};
</script>

<style scoped>
/* Styles to ensure the design matches the project */
</style>
